// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".services-dropdown-item-open p{font-size:13px;line-height:22px}", ""]);
// Exports
module.exports = exports;
